module.exports = __webpack_public_path__ + "static/media/hydroponic_farm_img.1ceec7f3.webp";